import { FORM_ERROR } from 'final-form';
import { OK } from 'http-status-codes';
import { call, put, select, takeLatest } from 'redux-saga/effects';

import { formatApiErrors, safeResolveAsync } from '../../../utils';
import { getFirebaseBridge } from '../firebaseBridge';
import * as tokensModule from '../tokens';
import { login } from './api';
import { actions, types } from './duck';

function* signOutFirebase() {
  const { signOut } = getFirebaseBridge();
  if (!signOut) {
    return;
  }
  try {
    yield call(signOut);
  } catch (error) {
    // No Firebase session to sign out of.
  }
}

// A login on top of an existing session (business <-> customer) must not
// inherit the previous identity's data: run reset sagas, then start from
// empty tokens so takeAuth sagas re-fire for the new identity.
export function* replaceExistingSession() {
  const hadSession = yield select(state => Boolean(state.auth.tokens.access));
  if (hadSession) {
    yield put(actions.switchSession());
    yield put(tokensModule.actions.clearTokens());
  }
}

export function* loginSaga({ email, password, firebaseIdToken, resolve }) {

  try {
    if (firebaseIdToken) {
      yield put(actions.loginRequest({ email }));

      yield call(replaceExistingSession);

      yield put(
        tokensModule.actions.setTokens({
          access: firebaseIdToken,
          refresh: null,
        }),
      );
      yield put(
        actions.loginSuccess({ access: firebaseIdToken, refresh: null }),
      );
      yield safeResolveAsync(resolve);
      return;
    }

    yield put(actions.loginRequest({ email, password }));

    const response = yield login(email, password);

    if (response.status === OK) {
      // Backend (business) login: drop any lingering Firebase customer session.
      yield call(signOutFirebase);
      yield call(replaceExistingSession);
      yield put(tokensModule.actions.setTokens(response.data));
      yield put(actions.loginSuccess(response.data));
      yield safeResolveAsync(resolve);
    } else {
      if (response.data.detail) {
        throw Error(response.data.detail);
      }
      const formatedErrors = formatApiErrors(response.data);
      yield put(actions.loginFailure(formatedErrors));
      yield safeResolveAsync(resolve, formatedErrors);
    }
  } catch (error) {
    yield put(actions.loginFailure(error.message));
    yield safeResolveAsync(resolve, { [FORM_ERROR]: error.message });
  }
}

export function* logoutSaga() {
  yield call(signOutFirebase);
  yield put(tokensModule.actions.clearTokens());
}

export default function* saga() {
  yield takeLatest(types.LOGIN, loginSaga);
  yield takeLatest(types.LOGOUT, logoutSaga);
}